import { IconArrowLeft } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Button from "../../components/Button";
import StepWizard from "./Stepper";
import PurchaseInformation from "./PurchaseInformation";
import { FormProvider, useForm } from "react-hook-form";
import CustomerInfromation from "./CustomerInfromation";
import StoreInformation from "./StoreInformation";
import AddContactItem from "./AddContactItem";
import RoundStepper from "./RoundStepper";
import { connect, useDispatch } from "react-redux";
import { AddContractSteps } from "./types";
import { createPendingContract } from "../../store/pending-contract/actions";
import { mapFormValuesToContract } from "../../store/pending-contract/helper";
import { PendingContractScope } from "../../store/pending-contract/types";
import { isScopeLoading } from "../../store/scope-loading/helpers";
import { RootState } from "../../store/root-reducer";
import UploadInvoice from "./UploadInvoice";
import Successful from "./Successful";
import NotAuthorizedPage from "../../components/NotAuthorizedPage";

function AddContracts({ loading, isAuthorized }) {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const formMethods = useForm({});
  const { handleSubmit } = formMethods;

  const dispatch = useDispatch();

  const stepComponent = (step: Number) => {
    switch (step) {
      case 1:
        return <UploadInvoice key="step1" />;
      case 2:
        return <PurchaseInformation key="step2" />;
      case 3:
        return <CustomerInfromation key="step3" />;
      case 4:
        return <StoreInformation key="step4" />;
      case 5:
        return <AddContactItem key="step5" />;
      case 6:
        return <Successful key="step6" />;
      default:
        return null;
    }
  };

  const handleNext = (values: any) => {
    switch (currentStep) {
      case 1:
        setCurrentStep(2);
        break;

      case 2:
        setCurrentStep(3);
        break;

      case 3:
        setCurrentStep(4);
        break;

      case 4:
        setCurrentStep(5);
        break;

      case 5:
        dispatch(
          createPendingContract(mapFormValuesToContract(values), () =>
            setCurrentStep(6)
          )
        );
        break;
      default:
    }
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = true;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);

  if (!isAuthorized) {
    return <NotAuthorizedPage />;
  }

  return (
    <div className="container">
      <div className="sm:pt-9 pt-6 pb-6">
        <button
          className="flex gap-3 text-gray-700 items-center font-medium"
          onClick={() => navigate("/contracts")}
        >
          <IconArrowLeft />
          <p>Add Contract</p>
        </button>
      </div>
      <RoundStepper stepInfo={AddContractSteps} currentStep={currentStep} />
      <form onSubmit={handleSubmit(handleNext)}>
        <div className="bg-white border border-gray-200 rounded-xl overflow-hidden mb-10">
          <div className="grid gap-y-10 pt-9 pb-10 px-5">
            <StepWizard stepInfo={AddContractSteps} currentStep={currentStep} />
            <FormProvider {...formMethods}>
              {stepComponent(currentStep)}
            </FormProvider>
          </div>

          {currentStep < 6 && (
            <div className="border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3">
              <Button
                type="button"
                variant="gray"
                btnClassName="w-[120px]"
                disabled={currentStep === 1}
                onClick={() => setCurrentStep((o) => (o > 0 ? o - 1 : 1))}
              >
                Previous
              </Button>
              <Button
                type="submit"
                variant="blue"
                btnClassName="w-[120px]"
                isLoading={loading}
              >
                {currentStep > AddContractSteps.length ? "Submit" : "Next"}
              </Button>
            </div>
          )}
        </div>
      </form>
    </div>
  );
}

const mapStateProps = (state: RootState) => {
  return {
    loading: isScopeLoading(state.scopeLoading, PendingContractScope),
    isAuthorized:
      state.user.selectedOrg.permissions.includes("create:contract"),
  };
};

export default connect(mapStateProps)(AddContracts);
